<div class="checkout-shipping-address border mb-4">
  <div class="border-bottom">
    <h5 class="m-0 p-3">
      <span><fa-icon [icon]="['fas', 'home-alt']" /></span>
      {{ 'checkout.address.shipping.label' | translate }}
    </h5>
  </div>
  <div class="p-3">
    @if (shippingAddress$ | async; as address) {
    <div class="address-box">
      @if ((basketInvoiceAndShippingAddressEqual$ | async) === false) {
      <div class="float-right shipping-icon">
        <!-- edit shipping address -->
        @if (collapseChange | async) {
        <a
          [routerLink]="[]"
          class="btn-tool"
          [title]="'checkout.address.update.title' | translate : { '0': 'checkout.address.shipping.label' | translate }"
          (click)="showAddressForm(address)"
          data-testing-id="edit-shipping-address-link"
        >
          <fa-icon [icon]="['fas', 'pencil-alt']" />
        </a>
        }
        <ish-modal-dialog
          #modalDialog
          [options]="{
            titleText: 'checkout.address.delete.confirmation.heading' | translate,
            confirmText: 'checkout.address.button.delete' | translate,
            rejectText: 'checkout.address.button.cancel' | translate
          }"
          (confirmed)="deleteAddress($event)"
        >
          <p>{{ 'checkout.address.delete.confirmation.text' | translate }}</p>
          <small class="text-muted">{{ 'checkout.address.delete.confirmation.deletionhint' | translate }}</small>
        </ish-modal-dialog>
      </div>
      <!-- display shipping address -->
      <ish-address [address]="address" [displayEmail]="true" />
      } @if (basketInvoiceAndShippingAddressEqual$ | async) {
      <p data-testing-id="sameAsInvoice" class="section">
        {{ 'checkout.same_as_billing_address.text' | translate }}
      </p>
      }
      <p></p>
    </div>
    @if (!address && showErrors) {
    <p class="text-danger">
      {{ 'checkout.addresses.no_Selection.shipping.error' | translate }}
    </p>
    } }
  </div>

  <!-- shipping address selection -->

  <div class="shipping-address p-3 pt-0">
    @if (addresses$ | async; as addresses) { @if (addresses.length) {
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" />
    </form>
    } }

    <!-- Add a new Shipping to address -->
    @if (displayAddAddressLink$ | async) {
    <div class="row">
      <button
        data-testing-id="create-shipping-address-link"
        class="btn btn-link"
        (click)="showAddressForm()"
        [attr.aria-expanded]="(collapseChange | async) === false"
        aria-controls="shipping-address-panel"
      >
        {{ 'checkout.create_shipping_address.link' | translate }}
      </button>
    </div>
    }

    <!-- shipping address form -->
    <div id="shipping-address-panel" [ngbCollapse]="collapseChange | async" data-testing-id="shipping-address-form">
      <ish-formly-customer-address-form
        [address]="editAddress"
        [resetForm]="collapseChange | async"
        [extension]="(isLoggedIn$ | async) === false"
        (save)="saveAddress($event)"
        (cancel)="cancelEditAddress()"
      />
    </div>

    @if ((collapseChange | async) === false) {
    <ish-lazy-address-doctor />
    }
  </div>
</div>
<!--  -->
